import { render, staticRenderFns } from "./TwoChoice.vue?vue&type=template&id=7cdf0069"
import script from "./TwoChoice.vue?vue&type=script&lang=js"
export * from "./TwoChoice.vue?vue&type=script&lang=js"
import style0 from "./TwoChoice.vue?vue&type=style&index=0&id=7cdf0069&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports